// extracted by mini-css-extract-plugin
export default {"documents":"styles_documents__Vcx+E","title":"styles_title__Zn3Lr","disclaimerContainer":"styles_disclaimerContainer__ULeqo","disclaimer":"styles_disclaimer__ZVPS-"};